// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3b-1";
export var rateTableServiceLevelDropdown = "_3b-3";
export var rateTableTypeDropdown = "_3b-0";
export var rateTableValueModeDropdown = "_3b-2";